export default __webpack_public_path__ + "static/media/karthik.2bb7ab64.jpeg";